import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { TpvUserAccessRepository } from '@app/domain/ports/tpv/tpv-user-access.repository';
import { TpvUserAccess } from '@app/domain/models/tpv/tpv-user-access.model';

/** Caso de uso: obtener el árbol de accesos TPV del usuario. */
@Injectable({ providedIn: 'root' })
export class GetTpvUserAccessUseCase {
  private readonly repository = inject(TpvUserAccessRepository);

  execute(): Observable<TpvUserAccess> {
    return this.repository.getAccess();
  }
}
